import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Silence benign ResizeObserver loop errors surfaced by the dev overlay
window.addEventListener("error", (e) => {
  if (String(e.message || "").includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
  }
});

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
